// SPDX-License-Identifier: EUPL-1.2
// SPDX-FileCopyrightText: (c) c3tactile

export const environments = [
	{
		id: '',
		name: 'None',
		path: null,
	},
	{
		id: 'neutral', // THREE.RoomEnvironment
		name: 'Neutral',
		path: null,
	}
];
